(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["haven-brand-grid"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('haven-brand-slider')) {
    customElements.define('haven-brand-slider', class extends HTMLElement {
      connectedCallback() {
        if (this.hasAttribute('data-ready')) return;
        this.events = new AbortController();
        const options = { signal: this.events.signal };
        const track = this.querySelector('.haven-brand-slider__track');
        const viewport = this.querySelector('.haven-brand-slider__viewport');
        const original = track.firstElementChild;
        const toggle = this.querySelector('button');
        const clone = original.cloneNode(true);
        clone.setAttribute('data-brand-clone', '');
        clone.setAttribute('aria-hidden', 'true');
        clone.removeAttribute('aria-label');
        clone.querySelectorAll('[id], [data-shopify-editor-block]').forEach(element => {
          element.removeAttribute('id');
          element.removeAttribute('data-shopify-editor-block');
        });
        clone.querySelectorAll('a').forEach(link => link.setAttribute('tabindex', '-1'));
        track.append(clone);
        const motion = matchMedia('(prefers-reduced-motion: reduce)');
        const setPaused = paused => {
          this.toggleAttribute('data-paused', paused);
          toggle.setAttribute('aria-pressed', String(paused));
          toggle.textContent = paused ? 'Play brand slider' : 'Pause brand slider';
        };
        const respectMotion = () => {
          this.toggleAttribute('data-static', motion.matches);
          this.removeAttribute('data-motion-allowed');
          setPaused(motion.matches);
        };
        respectMotion();
        motion.addEventListener('change', respectMotion, options);
        toggle.addEventListener('click', () => {
          const paused = !this.hasAttribute('data-paused');
          if (!paused) {
            this.removeAttribute('data-static');
            this.setAttribute('data-motion-allowed', '');
            viewport.scrollLeft = 0;
          }
          setPaused(paused);
        }, options);
        original.addEventListener('focusin', event => {
          this.setAttribute('data-keyboard', '');
          event.target.scrollIntoView({ block: 'nearest', inline: 'nearest' });
        }, options);
        original.addEventListener('focusout', event => {
          if (!original.contains(event.relatedTarget)) {
            this.removeAttribute('data-keyboard');
            viewport.scrollLeft = 0;
          }
        }, options);
        this.setAttribute('data-ready', '');
        toggle.hidden = false;
      }

      disconnectedCallback() {
        this.events?.abort();
        this.querySelector('[data-brand-clone]')?.remove();
        this.removeAttribute('data-ready');
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.headerHeightMediaQuery = window.matchMedia('(max-width: 990px)');
      this.onHeaderHeightMediaChange = this.setHeaderHeight.bind(this);
      this.headerHeightMediaQuery.addEventListener('change', this.onHeaderHeightMediaChange);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
        return;
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      if (this.headerHeightMediaQuery && this.onHeaderHeightMediaChange) {
        this.headerHeightMediaQuery.removeEventListener('change', this.onHeaderHeightMediaChange);
      }

      if (!this.headerIsAlwaysSticky) {
        this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
        window.removeEventListener('scroll', this.onScrollHandler);
      }
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
